import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import { ShoppingCart, ListAlt, SwapHoriz } from '@mui/icons-material';

const tiles = [
  { label: 'Purchase Orders',    icon: ShoppingCart, color: '#2e7d32', path: '/payables/orders',         desc: 'Raise and post orders to suppliers' },
  { label: 'Store Requisitions', icon: ListAlt,      color: '#4527a0', path: '/payables/requisitions',   desc: 'Issue items from store to departments' },
  { label: 'Transfer Orders',    icon: SwapHoriz,    color: '#00695c', path: '/procurement/transfers',   desc: 'Move stock between departments or GL accounts' },
];

const ProcurementDashboard = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6f8', py: 4 }}>
      <Box sx={{ maxWidth: 900, mx: 'auto', px: 3 }}>
        <Box sx={{
          p: 3, mb: 4, borderRadius: 3,
          background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
          color: '#fff', boxShadow: 3
        }}>
          <Typography variant="h4" fontWeight={700}>Procurement</Typography>
          <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
            Purchase orders, store requisitions and stock transfers
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {tiles.map(({ label, icon: Icon, color, path, desc }) => (
            <Grid item xs={12} sm={6} md={4} key={label}>
              <Card sx={{
                borderRadius: 3, cursor: 'pointer', height: '100%',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': { boxShadow: 6, transform: 'translateY(-4px)' }
              }} onClick={() => navigate(path)}>
                <CardContent>
                  <Box display="flex" alignItems="center" gap={2} mb={1}>
                    <Box sx={{
                      width: 48, height: 48, flexShrink: 0, borderRadius: '50%',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      bgcolor: `${color}1A`
                    }}>
                      <Icon sx={{ fontSize: 24, color }} />
                    </Box>
                    <Typography variant="h6" fontWeight={600}>{label}</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">{desc}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ProcurementDashboard;
